import React, { useRef } from 'react';

import { Lottie } from '@uncinc/uncinc-react-kitchen-sink';

import lottieData from './scroll-indicator-lottie.json';

import './style.scss';

let scrollIndicatorId = 0;

const ScrollIndicator = ({ onClick }) => {
  const lottie = useRef();

  return (
    <button type="button" className="ScrollIndicator" onClick={onClick} aria-label="scroll-indicator">
      <Lottie
        id={`ScrollIndicator-${scrollIndicatorId += 1}`}
        data={lottieData}
        onInit={(l) => lottie.current = l}
        onMouseEnter={() => lottie.current.pause()}
      />
    </button>
  );
};

export default ScrollIndicator;
